import React from 'react';
import { motion } from 'framer-motion';
export function ProductStrip() {
  const specs = ['1 scoop = daily ritual', '2 scoops = high-output days', '125mg caffeine per scoop', 'Hydration-first base'];
  return <section className="w-full bg-lime py-6" data-id="element-130">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center space-y-3" data-id="element-132">
          <h3 className="font-headline text-2xl md:text-3xl text-charcoal" data-id="element-133">
            Zesty Citrus — 40 Servings
          </h3>
          <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-charcoal font-medium" data-id="element-134">
            {specs.map((spec, i) => <span key={i} data-id="element-135">{spec}</span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}